import { useContext, useEffect, useState } from 'react';

// import { LanguageContext } from '../context/LanguageContext';
// import languageData from '../i18n/translations.json';

import ProjectCard from '../components/ProjectCard';

import { LanguageContext } from '../context/LanguageContext';
import { loadJson } from '../utils/loadJson'; 

const Projects = () => {
    const { language } = useContext(LanguageContext);
    const [translations, setTranslations] = useState({});
    const [projects, setProjects] = useState([]);


 

        useEffect(() => {
            // Cargar cada JSON de forma independiente y asignarlo a su variable
            const fetchTranslations = async () => {
                const data = await loadJson(`${process.env.PUBLIC_URL}/json/translations.json`);
                setTranslations(data);
            };
    
            const fetchProjects = async () => {
                const data = await loadJson(`${process.env.PUBLIC_URL}/json/projects.json`);
                setProjects(data);
            };
    
            fetchTranslations();
            fetchProjects();
    
       
    
        }, []);

    const t = translations[language] || {};
    return (
        <div className="wrapper">
            <h2>{t.nav?.projects}</h2>

            <div className="cardContent">
                {projects.map((project, index) => (
                    <ProjectCard key={index} project={project} />
                ))}
            </div>
        </div>
    );
};

export default Projects;